const {
  evaluateSource
} = require(/* configBehaviorIgnore: true */'../../lib/evaluateSource');
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined) {
    return undefined;
  }
  const maximum = await evaluateSource(source.maximum, content, parentContentPath, transientContext, nativeFunctions);
  const minimum = await evaluateSource(source.minimum, content, parentContentPath, transientContext, nativeFunctions);
  let nonConforming = false;
  if (maximum !== undefined && minimum !== undefined) {
    nonConforming = value <= minimum || value > maximum;
  } else if (maximum !== undefined) {
    nonConforming = value > maximum;
  } else if (minimum !== undefined) {
    nonConforming = value <= minimum;
  }
  return nonConforming;
};
module.exports = {
  evaluate
};